var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2944 0.232178C8.45603 0.232178 5.73138 1.32735 3.72595 3.27486C1.71844 5.22315 0.5904 7.8654 0.589844 10.6206C0.589844 13.3747 1.71884 16.0189 3.72595 17.9664C5.73138 19.9139 8.45603 21.0091 11.2944 21.0091C14.1328 21.0091 16.8575 19.9139 18.8629 17.9664C20.87 16.0189 21.999 13.3747 21.999 10.6206C21.999 7.86657 20.87 5.22238 18.8629 3.27486C16.8575 1.32735 14.1328 0.232178 11.2944 0.232178Z",
    fill: "url(#paint0_linear_9_3437)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83142 9.97366C9.00277 8.6594 11.117 7.79287 12.1741 7.37424C15.1959 6.17882 15.823 5.97121 16.2326 5.96417C16.3227 5.9628 16.5232 5.98398 16.6541 6.08464C16.7629 6.16953 16.7935 6.28433 16.8088 6.36494C16.8224 6.44546 16.8411 6.62898 16.8258 6.77225C16.6626 8.40861 15.9539 12.3795 15.5936 14.2124C15.4423 14.9878 15.1415 15.2479 14.8509 15.2732C14.2187 15.3285 13.7394 14.8761 13.1276 14.4947C12.1707 13.8975 11.6303 13.526 10.7006 12.9434C9.6265 12.2701 10.3233 11.8999 10.9351 11.2952C11.0949 11.1369 13.8787 8.72844 13.9314 8.50999C13.9382 8.48266 13.945 8.3808 13.8805 8.32711C13.8176 8.27327 13.7241 8.2917 13.6561 8.30625C13.5592 8.32695 12.0313 9.28872 9.06735 11.1914C8.63397 11.475 8.24137 11.6133 7.88787 11.606C7.50037 11.5981 6.75257 11.3971 6.19682 11.2253C5.51701 11.0147 4.97485 10.9032 5.02244 10.5454C5.04624 10.3591 5.31646 10.1685 5.83142 9.97366Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_3437",
    x1: 1071.05,
    y1: 0.232178,
    x2: 1071.05,
    y2: 2077.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.5fd1d17ef0fa32d8122e0936ec59538d.svg";
export { ForwardRef as ReactComponent };